import Vue from "vue";
import Vuex from "vuex";
import {
  Message
} from 'element-ui';
import {
  transToUpperCase
} from '@/tools/helper.js'

// import students from "./modules/students";
// import teachers from "./modules/teachers";
// 全局广播
import states from "./state.js";
import Api from '@/api/index.js';
// import loginApi from "@/api/login.js";
// import Api from "@/api/common.js";
import types from "@/constants/types";
import questionType from "@/constants/questionType";
import router from '@/router/index.js';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const defineStore = new Vuex.Store({
  modules: {
    // students,
    // teachers
  },
  state: states.rootState,
  getters: {
    uploadImgurl(state, getters, rootState) {
      return state.imgurl;
    },
    getExamPaperPositions(state, getters, rootState) {
      return state.examPaperPositions;
    },
    headerimgurl(state, getters, rootState) { //用户头像
      return state.headerimgurl;
    },
    nikename(state, getters, rootState) { //用户头像
      return state.nikename;
    },
    isShowLogin(state, getters, rootState) { // 显示登录弹窗
      return state.isShowLogin;
    },
    getTagsItem: (state) => state.tagsList, //tab 切换
    isToggleTheme: (state) => state.isToggleTheme, //是否切换主题
  },
  mutations: {
    // tab 的操作
    clearTags(state, status) {
      state.tagsList = [];
    },
    closeTagsOther(state, status) {
      state.tagsList = status;
    },
    setToggleTheme(state, status) {
      state.isToggleTheme = status;
    },
    delTagsItem(state, status) { // 删除tab
      state.tagsList = state.tagsList.filter(v => v.id != status.id);
    },
    setTagsItem(state, status) { // 新增tab
      if (!state.tagsList.find(v => v.id == status.id)) {
        state.tagsList.push(status);
      }
    },
    [types.TOPICLOADED](state, value) { // 是否加载完成
      state.topicLoaded = value;
    },
    [types.TITLENAME](state, value) {
      state.titleName = value;
    },
    [types.PERSONALDETAILS](state, value) {
      state.personalDetails = value;
      sessionStorage.setItem('personalDetails', JSON.stringify(value))
    },
    [types.USERINFO](state, value) {
      state.userInfo = value;
      sessionStorage.setItem('UserInfo', JSON.stringify(value))
      sessionStorage.setItem('AccessToken', value.accessToken)
    },
    [types.ModifyNickname](state, value) {

      state.userInfo.name = value;
      sessionStorage.setItem('UserInfo', JSON.stringify(state.userInfo))
      sessionStorage.setItem('AccessToken', state.userInfo.accessToken)
    },

    [types.LOGINOUT](state, value) {
      console.log(state)
      state.userInfo = {};
      state.personalDetails = {}
      sessionStorage.removeItem('state');
      sessionStorage.removeItem('AccessToken');
      sessionStorage.removeItem("UserInfo");
      // alert("000")
      sessionStorage.removeItem("personalDetails");
      sessionStorage.removeItem("menus");
      sessionStorage.removeItem("userType");
      // window.location.href = "/";
      router.push('/new_index');
      state.isVipUser = false;
      state.isBuy = false;
      // router.push('/Login');
      // router.push('/Home');

    },
    //是否显示登录弹窗
    [types.ISSHOWLOGIN](state, value) {
      state.isShowLogin = value;
      sessionStorage.setItem('isShowLogin', JSON.stringify(value));
    },
  },
  actions: {
    [types.AUTHENTICATION](context, args) {
      Api.GetPersonalDetails(args).then(res => {
        if (res) {
          // context.commit(types.AUTHENTICATION, res.data);
          context.commit(types.PERSONALDETAILS, res.data);
          //以下无用
          // console.log(JSON.parse(sessionStorage.getItem("personalDetails")))
          // if(sessionStorage.getItem("personalDetails")){
          //   let personal = JSON.parse(sessionStorage.getItem("personalDetails"));
          //   if(personal.userType==0){
          //     sessionStorage.setItem("userType",2)
          //   }else{
          //     sessionStorage.setItem("userType",personal.userType)
          //   }
          // }
        }
      }).catch(err => {
        console.log('err', err);
      })
    },
  },
  strict: debug
});

export default defineStore;



// WEBPACK FOOTER //
// ./src/store/index.js